// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__lMzVh","savePackageButton":"ClientWallet_savePackageButton__2Q0_b"};